import { toDateFromServer } from "../api/dates";

export type SetDayMenuRange = {
    start: string;
    end: string;
    price: number;
};

function isRangeEntry(val: unknown): val is SetDayMenuRange {
    if (!val || typeof val !== "object") {
        return false;
    }
    const v = val as Record<string, unknown>;
    return typeof v.start === "string" && typeof v.end === "string" && v.price != null && !Number.isNaN(Number(v.price));
}

/** `Ranges/{pushId}` entries with start, end, price. */
function listSetDayMenuRanges(root: Record<string, unknown> | null | undefined): SetDayMenuRange[] {
    if (!root) {
        return [];
    }
    return Object.values(root).filter(isRangeEntry).map((val) => ({
        start: val.start,
        end: val.end,
        price: Number(val.price),
    }));
}

export function findSetDayMenuRangeForDate(root: Record<string, unknown> | null | undefined, date: string): SetDayMenuRange | null {
    if (!date) {
        return null;
    }
    const dateObj = toDateFromServer(date);
    return listSetDayMenuRanges(root).find(
        (range) => dateObj >= toDateFromServer(range.start) && dateObj <= toDateFromServer(range.end)
    ) ?? null;
}
